import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyParticipants } from '@/features/my-participants'
import z from 'zod'

const searchSchema = z.object({
  search: z.string().optional().catch(''),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/my-participants/'
)({
  validateSearch: searchSchema,
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: MyParticipants,
})
